export default __webpack_public_path__ + "static/media/splash.c362397c.png";